import { OrthographicCamera, Scene, Vector3 } from "three";
import { inject, ref } from "vue";

export const sceneInjectionKey = Symbol("scene");
export const cameraInjectionKey = Symbol("camera");
export const canvasInjectionKey = Symbol("canvas");
export const viewportOffsetInjectionKey = Symbol("viewportOffset");

type CanvasSettings = { width: number,
  height: number,
  requestRender: () => void, };

export default function useThreeElement () {
  const scene = inject<Scene>(sceneInjectionKey, new Scene());
  const camera = inject<OrthographicCamera>(cameraInjectionKey, new OrthographicCamera());
  const canvas = inject<CanvasSettings>(canvasInjectionKey, {
    width: 1024,
    height: 768,
    requestRender: () => { },
  });
  const viewportOffset = inject(viewportOffsetInjectionKey, ref(new Vector3()));

  return {
    scene,
    camera,
    canvas,
    viewportOffset,
  };
}
